import { COLORS } from './Color';
export const styles = {
  container: {
    display: 'flex',
    flexDirection: 'column' as 'column',
    width: '360px',
    backgroundColor: '#FFFFFF',
    // height: window.innerHeight,
    position: 'relative' as 'relative',
  },
  searchContainer: {
    display: 'flex',
    flexDirection: 'column' as 'column',
  },
  searchTitle: {
    width: '100%',
    fontFamily: 'Spoqa Han Sans Neo',
    fontSize: '16px',
    fontWeight: 700,
    lineHeight: '23.2px',
    paddingTop: '32px',
    paddingLeft: '16px',
    paddingBottom: '16px',
  },
  searchOptionBox: {
    width: '100%',
    paddingBlock: '12px',
    paddingInline: '16px',
    borderBottom: '1px solid ' + COLORS.borderGray,
    borderBottomColor: COLORS.borderGray,
    display: 'flex',
    flexDirection: 'row' as 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  searchOptionBoxLeft: {
    display: 'flex',
    flexDirection: 'row' as 'row',
    justifyContent: 'flex-start',
    alignItems: 'center',
    gap: '8px',
  },
  rotatedImage: {
    transform: [{ rotate: '180deg' }],
  },
  filterWrapper: {
    display: 'flex',
    borderBottom: '1px solid #171E261A',
    borderBottomColor: '#171E261A',
    paddingBlock: '12px',
    paddingInline: '16px',
  },
  filter: {
    display: 'flex',
    paddingBlock: '8px',
    paddingInline: '12px',
    flexDirection: 'row' as 'row',
    borderRadius: '100px',
    gap: '4px',
    border: '1px solid #171E26',
    borderColor: '#171E26',
    flexWrap: 'nowrap' as 'nowrap',
    cursor: 'pointer',
    height: '36px',
  },
  filterActive: {
    backgroundColor: COLORS.primary,
  },

  filterText: {
    fontFamily: 'Spoqa Han Sans Neo',
    fontSize: '14px',
    fontWeight: 500,
    lineHeight: '20.3px',
    flexWrap: 'nowrap' as 'nowrap',
    textAlign: 'center' as 'center',
    textWrap: 'nowrap',
  },
  filterTextActive: {
    color: '#FFFFFF',
  },

  filterListWrapper: {
    display: 'flex',
    flexDirection: 'row' as 'row',
    justifyContent: 'space-between',
    alignItems: 'flex-end',
    paddingBlock: '12px',
    paddingInline: '16px',
    backgroundColor: '#F0F0F0',
  },
  filterListInner: {
    width: '254px',
    display: 'flex',
    flexDirection: 'row' as 'row',
    flexWrap: 'wrap' as 'wrap' as 'wrap',
    gap: '8px',
  },
  filterList: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    paddingBlock: '6px',
    paddingInline: '12px',
    borderRadius: '999px',
    backgroundColor: '#171E268F',
    flexDirection: 'row' as 'row',
  },
  selectedFilterText: {
    fontFamily: 'Spoqa Han Sans Neo',
    fontSize: '13px',
    fontWeight: 500,
    lineHeight: '18.85px',
    color: '#FFFFFF',
    textAlign: 'center' as 'center',
  },
  totalCntWrapper: {
    display: 'flex',
    flexDirection: 'row' as 'row',
    justifyContent: 'space-between',
    padding: '16px',
    borderBottomColor: '#171E261A',
    borderBottom: '1px solid #171E261A',
    backgroundColor: '#F7F8F9',
  },
  totalCntText: {
    fontFamily: 'Spoqa Han Sans Neo',
    fontSize: '14px',
    fontWeight: 500,
    lineHeight: '18.85px',
    textAlign: 'left' as 'left',
    color: COLORS.secondary,
    cursor: 'pointer',
  },
  totalCntTextBold: {
    fontFamily: 'Spoqa Han Sans Neo',
    fontSize: '14px',
    lineHeight: '18.85px',
    fontWeight: 700,
    textAlign: 'left' as 'left',
    color: COLORS.secondary,
  },
  sortWarpper: {
    display: 'flex',
    flexDirection: 'row' as 'row',
    gap: '12px',
  },
  totalStyle: {
    display: 'flex',
    flexDirection: 'row' as 'row',
    paddingInline: '16px',
    paddingBlock: '16px',
    justifyContent: 'space-between',
  },
  searchBox: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    padding: '16px',
    flexDirection: 'row' as 'row',
    borderBottom: '1px solid ' + COLORS.borderGray,
    borderBottomColor: COLORS.borderGray,
  },
  searchInner: {
    display: 'flex',
    flexDirection: 'row' as 'row',
    borderRadius: '100px',
    border: '1.5px solid ' + COLORS.primary,
    borderColor: COLORS.primary,
    justifyContent: 'space-between',
    alignItems: 'center',
    width: '100%',
    paddingInline: '16px',
    height: '47px',
  },
  icon: {
    width: '24px',
    height: '24px',
    cursor: 'pointer',
  },
  input: {
    borderWidth: '0px',
    fontFamily: 'Spoqa Han Sans Neo',
    fontSize: '16px',
    fontWeight: 500,
    lineHeight: '23.2px',
    textAlign: 'left' as 'left',
    width: '100%',
  },
  placeholder: {
    fontFamily: 'Spoqa Han Sans Neo',
    fontSize: '16px',
    fontWeight: 500,
    lineHeight: '23.2px',
    textAlign: 'left' as 'left',
  },
  divider: {
    height: '1px',
    backgroundColor: '#171E261A',
    marginHorizontal: '16px',
  },
  scrollView: {
    flex: 1,
    paddingBlock: '24px',
    paddingInline: '16px',
    overflow: 'auto',
    flexShrink: 1,
    flexGrow: 1,
  },
  listItem: {
    display: 'flex',
    flexDirection: 'column' as 'column',
    borderBottom: '1px solid #171E261A',
    borderBottomColor: '#171E261A',
    paddingBottom: '16px',
    marginBottom: '24px',
    gap: '8px',
  },
  header: {
    display: 'flex',
    flexDirection: 'row' as 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    width: '100%',
    flexWrap: 'wrap' as 'wrap',
  },
  headerText: {
    fontFamily: 'Spoqa Han Sans Neo',
    fontSize: '13px',
    fontWeight: 500,
    lineHeight: '18.85px',
    color: '#171E268F',
  },
  headerText_margin: {
    fontFamily: 'Spoqa Han Sans Neo',
    fontSize: '13px',
    fontWeight: 500,
    lineHeight: '18.85px',
    color: '#171E268F',
    marginRight: '8px',
    marginLeft: '8px',
  },
  content: {
    display: 'flex',
    flexDirection: 'row' as 'row',
    justifyContent: 'space-between',
  },
  contentText: {
    display: 'flex',
    flexDirection: 'column' as 'column',
    width: '232px',
    gap: '8px',
  },
  title: {
    fontFamily: 'Spoqa Han Sans Neo',
    fontSize: '14px',
    fontWeight: 700,
    lineHeight: '20.3px',

    color: '#171E26',
  },
  price: {
    fontFamily: 'Spoqa Han Sans Neo',
    fontSize: '14px',
    fontWeight: 700,
    lineHeight: '20.3px',
    color: '#008AFF',
  },
  bidPrice: {
    fontFamily: 'Spoqa Han Sans Neo',
    fontSize: '14px',
    fontWeight: 700,
    lineHeight: '20.3px',
    color: '#F45551',
  },
  aprice: {
    fontFamily: 'Spoqa Han Sans Neo',
    fontSize: '14px',
    fontWeight: 700,
    lineHeight: '20.3px',
    color: '#171E26',
  },
  tags: {
    display: 'flex',
    flexDirection: 'row' as 'row',
    gap: '6px',
    flexWrap: 'wrap' as 'wrap',
  },
  tag: {
    display: 'flex',
    flexDirection: 'row' as 'row',
    justifyContent: 'center',
    alignItems: 'center',
    width: 'auto',
    borderRadius: '4px',
    padding: '4px 8px',
    color: 'rgba(55, 56, 60, 0.61)',
    backgroundColor: 'rgba(112, 115, 124, 0.08)',
  },
  tagClick: {
    cursor: 'pointer',
    display: 'flex',
    flexDirection: 'row' as 'row',
    justifyContent: 'center',
    alignItems: 'center',
    width: 'auto',
    borderRadius: '4px',
    padding: '4px 8px',
    color: 'rgba(55, 56, 60, 0.61)',
    backgroundColor: 'rgba(112, 115, 124, 0.08)',
  },
  isbidtag2: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    width: 'auto',
    borderRadius: '8px',
    paddingBlock: '4px',
    paddingInline: '8px',
    backgroundColor: '#2e9640',
  },
  isbidtag: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    width: 'auto',
    borderRadius: '8px',
    paddingBlock: '4px',
    paddingInline: '8px',
    backgroundColor: '#535AFF',
  },
  isblocktag: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    width: 'auto',
    borderRadius: '8px',
    paddingBlock: '4px',
    paddingInline: '8px',
    backgroundColor: '#7435bd',
  },
  tagText: {
    fontFamily: 'Spoqa Han Sans Neo',
    fontSize: '12px',
    fontWeight: 500,
    lineHeight: '17.4px',
    color: '#171E268F',
  },
  isbidtagText: {
    fontFamily: 'Spoqa Han Sans Neo',
    fontSize: '12px',
    fontWeight: 500,
    lineHeight: '17.4px',
    color: '#fff',
  },

  imageBox: {
    display: 'flex',
    flexDirection: 'column' as 'column',
    justifyContent: 'center',
    alignItems: 'center',
    gap: '4px',
    with: 80,
  },
  viewCount: {
    width: '100%',
    display: 'flex',
    flexDirection: 'row' as 'row',
    justifyContent: 'flex-end',
    alignItems: 'center',
    fontFamily: 'Spoqa Han Sans Neo',
    fontSize: '12px',
    fontWeight: 400,
    color: `rgba(55, 56, 60, 0.61)`,
  },
  imagePlaceholder: {
    width: '80px',
    height: '80px',
    backgroundColor: '#F7F8F9',
    borderRadius: '8px',
  },
  typeTag: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    paddingBlock: '2px',
    paddingInline: '8px',
    borderRadius: '999px',
    marginLeft: 'auto',
  },
  typeTagText: {
    fontFamily: 'Spoqa Han Sans Neo',
    fontSize: '13px',
    fontWeight: 500,
    lineHeight: '18.85px',
  },
};
